module.exports = __webpack_public_path__ + "static/img/Villaya-Microgrid_SAM_1992.71587a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Villaya-Microgrid_SAM_1992.jpg
// module id = VsbL
// module chunks = 0